import SWL from '../assets/workshops/Photo SWD (1).jpg';

export const WorkshopsList = [
  {
    name: 'The Electrified Interface – Electrochemical Methods of Characterization',
    instructors: ['Scott Donne'],
    institution: 'CNyN-UNAM',
    summary:
      'The electrified interface between an electronically conducting electrode and an ionically conducting electrolyte is an important region of interest in electrochemistry. For energy storage and conversion systems this is of particular importance because the processes occurring at this interface play a key role in system performance. This tutorial session will focus on developing insight into the electrified interface and how its contributions to performance can be determined.',
    img: SWL,
  }
];




